import { createContext, useContext, useState } from "react";

export const translations = {
  en: {
    nav_packages: "Packages",
    nav_facilities: "The Arena",
    nav_franchise: "Franchise",
    nav_shop: "Shop",
    nav_contact: "Contact",
    nav_admin: "Admin",
    enroll: "Enroll Now",
    hero_badge: "West Bengal's Hardest-Working Gym — Since 2015",
    hero_lines: ["FORGE YOUR", "STRONGEST", "SELF."],
    hero_sub: "Real iron. Real coaches. Real results. Pick a package, drop your details, pay at the desk — that's it.",
    hero_cta_primary: "Enroll Now",
    hero_cta_secondary: "View Packages",
    stat_members: "Running Members",
    stat_trainers: "Pro Coaches",
    stat_open: "Open Daily",
    stat_machines: "Machines & Racks",
    packages_kicker: "Membership",
    packages_title: "CHOOSE YOUR WEAPON",
    packages_sub: "Transparent pricing. No hidden fees. Enroll online, pay at the gym desk.",
    admission_fee_note: "One-time admission fee ₹1,000 — pay once, be a Fitnastic member for life.",
    popular: "Most Popular",
    enroll_now: "Enroll Now",
    facilities_kicker: "The Arena",
    facilities_title: "BUILT FOR WORK",
    facilities_chips: ["Modern Equipments", "Expert Trainers", "Personalised Workout Plan", "Diet & Nutrition Guidance", "Friendly Environment", "AC Gym Facility", "Locker & Changing Room", "Safe & Hygienic"],
    cta_title: "JOIN TODAY FOR A STRONGER TOMORROW.",
    cta_sub: "First-timers get a free assessment session. Enroll online, pay at the desk.",
    footer_tagline: "Fitness • Health • Better You",
    footer_address: "Katapukur More (Near V-Mart), GT Road, West Bengal",
    footer_hours_title: "Hours",
    footer_hours: "Mon – Sat: 6:00 AM – 10:00 PM",
    footer_hours2: "Sunday: 7:00 AM – 12:00 PM",
    footer_contact_title: "Contact",
    footer_rights: "All rights reserved.",
    footer_follow: "Follow Us",
    get_directions: "Get Directions",
    whatsapp_chat: "Chat on WhatsApp",
    form_title: "Admission Form",
    form_sub: "Fill in your details — pay at the gym front desk to activate your membership.",
    form_name: "Full Name",
    form_phone: "Contact Number",
    form_email: "Email ID (optional)",
    form_dob: "Date of Birth",
    form_address: "Address",
    form_id_proof: "Any ID Proof",
    form_id_number: "ID Card Number",
    id_proofs: ["Aadhaar", "PAN", "Voter ID", "Driving License", "College ID", "Other"],
    form_package: "Select Package",
    form_gender: "Gender",
    gender_male: "Male",
    gender_female: "Female",
    gender_other: "Other",
    form_height: "Height",
    form_weight: "Weight (kg)",
    form_goal: "Fitness Goal",
    goals: ["Weight Loss", "Muscle Gain", "General Fitness", "Other"],
    form_goal_other: "Specify your goal",
    form_slot: "Preferred Batch",
    slot_morning: "Morning (6 AM – 11 AM)",
    slot_evening: "Evening (4 PM – 8 PM)",
    slot_night: "Night (8 PM – 10 PM)",
    form_emergency_name: "Emergency Contact Name",
    form_emergency: "Emergency Contact Number",
    form_relation: "Relation",
    form_medical: "Any Medical Condition / Injury (optional)",
    sec_member: "Member Details",
    sec_fitness: "Fitness Details",
    sec_batch: "Batch Selection",
    sec_emergency: "Emergency Contact",
    sec_medical: "Medical Information (If any)",
    sec_terms: "Terms and Conditions",
    terms_points: [
      "All information provided in this form is true and correct to the best of my knowledge.",
      "The member will use the gym facilities at their own risk.",
      "The management is not responsible for any injury, accident or health issues during workout.",
      "Members must follow the gym rules, regulations and trainers' instructions.",
      "Maintain cleanliness, discipline and respect towards staff and other members.",
      "Loss or damage of personal belongings is not the responsibility of the gym.",
      "Any misconduct may lead to suspension or cancellation of membership without refund.",
      "Once the bill/payment is made, no amount is refundable under any circumstances.",
      "The management reserves the right to modify rules, timings or facilities without prior notice.",
    ],
    terms_agree: "I have read and understood all the terms and conditions mentioned above and agree to abide by them.",
    form_submit: "Submit Admission",
    form_submitting: "Submitting...",
    form_pay_note: "No online payment — pay ₹1,000 admission fee + package price at the gym desk.",
    success_title: "Admission submitted!",
    success_body: "Pay at the gym front desk to activate your membership.",
    error_generic: "Something went wrong. Please try again.",
    error_phone: "Enter a valid 10-digit mobile number",
    offer_ends_in: "Offer ends in",
    franchise_kicker: "Franchise",
    franchise_title: "OWN A FITNASTIC",
    franchise_sub: "Take West Bengal's hardest-working gym brand to your city. Share your details — our franchise team will call you back.",
    franchise_points: ["Proven brand running strong since 2015", "Complete setup, equipment & staff training support", "Marketing and grand-launch assistance", "Finance assistance available for franchise partners"],
    franchise_form_title: "Franchise Enquiry",
    fr_email: "Email (optional)",
    fr_city: "Your City",
    fr_budget: "Investment Budget",
    fr_budgets: ["Under ₹10 Lakhs", "₹10 – 20 Lakhs", "₹20 – 40 Lakhs", "₹40+ Lakhs"],
    fr_message: "Message (optional)",
    fr_submit: "Send Enquiry",
    fr_submitting: "Sending...",
    fr_success_title: "Enquiry sent!",
    fr_success_body: "Our franchise team will call you back soon.",
    fr_finance: "I need financing support to start my franchise",
    shop_kicker: "Pro Shop",
    shop_title: "FITNASTIC GYM EQUIPMENTS",
    shop_sub: "Setting up a gym? Buy pro-grade equipment straight from our shop — visit us or enquire on WhatsApp.",
    shop_visit_cta: "Visit Our Shop",
    shop_price_note: "Best price at shop",
    shop_enquire: "Enquire",
    shop_address: "Grand Trunk Rd, Opposite Bank of Maharashtra, Khagragarh More, West Bengal 713104",
    shop_home_note: "Home-use equipments starting from just ₹9,999",
    form_age: "Age",
    nav_aiplan: "AI Plan",
    ai_chat_title: "Fitnastic AI",
    ai_chat_greeting: "Hi! Ask me anything — packages, timing, offers or location.",
    ai_chat_placeholder: "Type your question...",
    ai_plan_kicker: "AI Coach",
    ai_plan_title: "YOUR AI FITNESS PLAN",
    ai_plan_sub: "Tell us your name, age and goal — our AI coach suggests a starter workout and diet plan instantly.",
    ai_plan_generate: "Generate My Plan",
    ai_plan_generating: "AI coach is preparing your plan...",
    ai_plan_disclaimer: "AI-generated suggestion only — your final plan will be set with our trainers at the gym.",
    ai_summary_button: "AI Summary",
    ai_summary_title: "AI Business Summary",
    pay_now: "Pay Online Now",
    pay_at_desk_btn: "Pay at Gym Desk",
    pay_saved_note: "Admission saved! Pay online now, or later at the gym desk.",
    pay_total: "Total Payable",
    admission_fee_short: "Admission fee",
    payment_success: "Payment successful! Your membership is activated.",
    payment_failed: "Payment failed or cancelled — you can pay at the gym desk.",
    book_advance: "Book · ₹1,000",
    book_success: "Booking advance paid! We will contact you soon.",
  },
  bn: {
    nav_packages: "প্যাকেজ",
    nav_facilities: "আমাদের জিম",
    nav_franchise: "ফ্র্যাঞ্চাইজি",
    nav_shop: "শপ",
    nav_contact: "যোগাযোগ",
    nav_admin: "অ্যাডমিন",
    enroll: "ভর্তি হন",
    hero_badge: "পশ্চিমবঙ্গের সেরা জিম — ২০১৫ সাল থেকে",
    hero_lines: ["নিজেকে গড়ো", "সবচেয়ে শক্তিশালী", "রূপে।"],
    hero_sub: "আসল আয়রন। আসল কোচ। আসল রেজাল্ট। প্যাকেজ বাছুন, তথ্য দিন, জিমে এসে পেমেন্ট করুন — ব্যস!",
    hero_cta_primary: "ভর্তি হন",
    hero_cta_secondary: "প্যাকেজ দেখুন",
    stat_members: "চলতি সদস্য",
    stat_trainers: "প্রফেশনাল কোচ",
    stat_open: "প্রতিদিন খোলা",
    stat_machines: "মেশিন ও র্যাক",
    packages_kicker: "মেম্বারশিপ",
    packages_title: "তোমার প্যাকেজ বেছে নাও",
    packages_sub: "সম্পূর্ণ স্বচ্ছ মূল্য, কোনো লুকানো চার্জ নেই। অনলাইনে ভর্তি ফর্ম পূরণ করুন, জিমে এসে পেমেন্ট করুন।",
    admission_fee_note: "এককালীন অ্যাডমিশন ফি ₹1,000 — একবার পেমেন্ট করুন, আজীবন ফিটন্যাস্টিক মেম্বার থাকুন।",
    popular: "জনপ্রিয়",
    enroll_now: "ভর্তি হন",
    facilities_kicker: "জিম",
    facilities_title: "কাজের জন্য তৈরি",
    facilities_chips: ["আধুনিক ইকুইপমেন্ট", "এক্সপার্ট ট্রেইনার", "পার্সোনালাইজড ওয়ার্কআউট প্ল্যান", "ডায়েট ও নিউট্রিশন গাইডেন্স", "বন্ধুসুলভ পরিবেশ", "এসি জিম সুবিধা", "লকার ও চেঞ্জিং রুম", "নিরাপদ ও পরিচ্ছন্ন"],
    cta_title: "আজই যোগ দিন, আগামীকাল হন শক্তিশালী।",
    cta_sub: "নতুনদের জন্য ফ্রি অ্যাসেসমেন্ট সেশন। অনলাইনে ভর্তি হন, ডেস্কে পেমেন্ট করুন।",
    footer_tagline: "ফিটনেস • স্বাস্থ্য • উন্নত তুমি",
    footer_address: "কাটাপুকুর মোড় (ভি-মার্টের কাছে), জিটি রোড, পশ্চিমবঙ্গ",
    footer_hours_title: "সময়সূচি",
    footer_hours: "সোম – শনি: সকাল ৬টা – রাত ১০টা",
    footer_hours2: "রবিবার: সকাল ৭টা – দুপুর ১২টা",
    footer_contact_title: "যোগাযোগ",
    footer_rights: "সর্বস্বত্ব সংরক্ষিত।",
    footer_follow: "ফলো করুন",
    get_directions: "দিকনির্দেশনা পান",
    whatsapp_chat: "হোয়াটসঅ্যাপে মেসেজ করুন",
    form_title: "ভর্তি ফর্ম",
    form_sub: "আপনার তথ্য পূরণ করুন — জিমের ফ্রন্ট ডেস্কে পেমেন্ট করে মেম্বারশিপ চালু করুন।",
    form_name: "পুরো নাম",
    form_phone: "যোগাযোগ নম্বর",
    form_email: "ইমেইল আইডি (ঐচ্ছিক)",
    form_dob: "জন্ম তারিখ",
    form_address: "ঠিকানা",
    form_id_proof: "আইডি প্রুফ",
    form_id_number: "আইডি কার্ড নম্বর",
    id_proofs: ["আধার", "প্যান", "ভোটার আইডি", "ড্রাইভিং লাইসেন্স", "কলেজ আইডি", "অন্যান্য"],
    form_package: "প্যাকেজ নির্বাচন",
    form_gender: "লিঙ্গ",
    gender_male: "পুরুষ",
    gender_female: "মহিলা",
    gender_other: "অন্যান্য",
    form_height: "উচ্চতা",
    form_weight: "ওজন (কেজি)",
    form_goal: "ফিটনেস লক্ষ্য",
    goals: ["ওজন কমানো", "মাসল গেইন", "জেনারেল ফিটনেস", "অন্যান্য"],
    form_goal_other: "আপনার লক্ষ্য লিখুন",
    form_slot: "পছন্দের ব্যাচ",
    slot_morning: "সকাল (৬টা – ১১টা)",
    slot_evening: "বিকাল (৪টা – ৮টা)",
    slot_night: "রাত (৮টা – ১০টা)",
    form_emergency_name: "জরুরি যোগাযোগের নাম",
    form_emergency: "জরুরি যোগাযোগ নম্বর",
    form_relation: "সম্পর্ক",
    form_medical: "শারীরিক সমস্যা / আঘাত (ঐচ্ছিক)",
    sec_member: "সদস্যের তথ্য",
    sec_fitness: "ফিটনেস তথ্য",
    sec_batch: "ব্যাচ নির্বাচন",
    sec_emergency: "জরুরি যোগাযোগ",
    sec_medical: "শারীরিক তথ্য (যদি থাকে)",
    sec_terms: "শর্তাবলী",
    terms_points: [
      "এই ফর্মে দেওয়া সব তথ্য আমার জানামতে সত্য ও সঠিক।",
      "সদস্য নিজ দায়িত্বে জিমের সুবিধা ব্যবহার করবেন।",
      "ওয়ার্কআউট চলাকালীন কোনো আঘাত, দুর্ঘটনা বা শারীরিক সমস্যার দায় জিম কর্তৃপক্ষ নেবে না।",
      "সদস্যদের জিমের নিয়ম, শৃঙ্খলা ও ট্রেইনারদের নির্দেশনা মেনে চলতে হবে।",
      "পরিষ্কার-পরিচ্ছন্নতা, শৃঙ্খলা ও স্টাফ এবং অন্য সদস্যদের প্রতি সম্মান বজায় রাখতে হবে।",
      "ব্যক্তিগত জিনিসপত্র হারানো বা নষ্ট হওয়ার দায় জিম নেবে না।",
      "কোনো অসদাচরণে রিফান্ড ছাড়াই মেম্বারশিপ স্থগিত বা বাতিল হতে পারে।",
      "বিল/পেমেন্ট হয়ে গেলে কোনো অবস্থাতেই টাকা ফেরত দেওয়া হবে না।",
      "জিম কর্তৃপক্ষ পূর্ব নোটিশ ছাড়াই নিয়ম, সময় বা সুবিধা পরিবর্তনের অধিকার রাখে।",
    ],
    terms_agree: "আমি উপরের সব শর্তাবলী পড়েছি ও বুঝেছি এবং মেনে চলতে সম্মত।",
    form_submit: "ভর্তি জমা দিন",
    form_submitting: "জমা হচ্ছে...",
    form_pay_note: "অনলাইন পেমেন্ট নেই — জিমের ডেস্কে ₹1,000 অ্যাডমিশন ফি + প্যাকেজ মূল্য পেমেন্ট করুন।",
    success_title: "ভর্তি জমা হয়েছে!",
    success_body: "জিমের ফ্রন্ট ডেস্কে পেমেন্ট করে মেম্বারশিপ চালু করুন।",
    error_generic: "কিছু একটা ভুল হয়েছে। আবার চেষ্টা করুন।",
    error_phone: "সঠিক ১০ সংখ্যার মোবাইল নম্বর দিন",
    offer_ends_in: "অফার শেষ হতে বাকি",
    franchise_kicker: "ফ্র্যাঞ্চাইজি",
    franchise_title: "নিজের ফিটন্যাস্টিক খুলুন",
    franchise_sub: "পশ্চিমবঙ্গের সেরা জিম ব্র্যান্ড আপনার শহরে নিয়ে যান। আপনার তথ্য দিন — আমাদের ফ্র্যাঞ্চাইজি টিম আপনাকে ফোন করবে।",
    franchise_points: ["২০১৫ সাল থেকে সফলভাবে চলমান ব্র্যান্ড", "সম্পূর্ণ সেটআপ, ইকুইপমেন্ট ও স্টাফ ট্রেনিং সাপোর্ট", "মার্কেটিং ও গ্র্যান্ড-লঞ্চ সহায়তা", "ফ্র্যাঞ্চাইজি পার্টনারদের জন্য ফাইন্যান্স সুবিধা আছে"],
    franchise_form_title: "ফ্র্যাঞ্চাইজি এনকোয়ারি",
    fr_email: "ইমেইল (ঐচ্ছিক)",
    fr_city: "আপনার শহর",
    fr_budget: "ইনভেস্টমেন্ট বাজেট",
    fr_budgets: ["₹১০ লক্ষের নিচে", "₹১০ – ২০ লক্ষ", "₹২০ – ৪০ লক্ষ", "₹৪০ লক্ষের বেশি"],
    fr_message: "মেসেজ (ঐচ্ছিক)",
    fr_submit: "এনকোয়ারি পাঠান",
    fr_submitting: "পাঠানো হচ্ছে...",
    fr_success_title: "এনকোয়ারি পাঠানো হয়েছে!",
    fr_success_body: "আমাদের ফ্র্যাঞ্চাইজি টিম শীঘ্রই আপনাকে ফোন করবে।",
    fr_finance: "ফ্র্যাঞ্চাইজি শুরু করতে ফাইন্যান্স সুবিধা লাগবে",
    shop_kicker: "প্রো শপ",
    shop_title: "ফিটন্যাস্টিক জিম ইকুইপমেন্ট",
    shop_sub: "জিম সাজাতে চাইছেন? আমাদের দোকান থেকে প্রো-গ্রেড ইকুইপমেন্ট কিনুন — দোকানে আসুন অথবা হোয়াটসঅ্যাপে জিজ্ঞেস করুন।",
    shop_visit_cta: "আমাদের দোকানে আসুন",
    shop_price_note: "সেরা দাম দোকানে",
    shop_enquire: "জিজ্ঞেস করুন",
    shop_address: "গ্র্যান্ড ট্রাঙ্ক রোড, ব্যাংক অফ মহারাষ্ট্রের বিপরীতে, খাগড়াগড় মোড়, পশ্চিমবঙ্গ ৭১৩১০৪",
    shop_home_note: "হোম-ইউজ ইকুইপমেন্ট মাত্র ₹9,999 থেকে শুরু",
    form_age: "বয়স",
    nav_aiplan: "এআই প্ল্যান",
    ai_chat_title: "ফিটন্যাস্টিক এআই",
    ai_chat_greeting: "হাই! প্যাকেজ, সময়, অফার বা ঠিকানা — যা জানতে চান জিজ্ঞেস করুন।",
    ai_chat_placeholder: "আপনার প্রশ্ন লিখুন...",
    ai_plan_kicker: "এআই কোচ",
    ai_plan_title: "তোমার এআই ফিটনেস প্ল্যান",
    ai_plan_sub: "নাম, বয়স আর লক্ষ্য দিন — আমাদের এআই কোচ সাথে সাথে শুরুর ওয়ার্কআউট ও ডায়েট প্ল্যান বানিয়ে দেবে।",
    ai_plan_generate: "আমার প্ল্যান বানাও",
    ai_plan_generating: "এআই কোচ আপনার প্ল্যান তৈরি করছে...",
    ai_plan_disclaimer: "এটা শুধু এআই-এর পরামর্শ — আসল প্ল্যান জিমে আমাদের ট্রেইনারদের সাথে ঠিক হবে।",
    ai_summary_button: "এআই সামারি",
    ai_summary_title: "এআই বিজনেস সামারি",
    pay_now: "অনলাইনে পেমেন্ট করুন",
    pay_at_desk_btn: "জিমের ডেস্কে পেমেন্ট করব",
    pay_saved_note: "ভর্তি সেভ হয়েছে! এখন অনলাইনে অথবা পরে জিমের ডেস্কে পেমেন্ট করুন।",
    pay_total: "মোট প্রদেয়",
    admission_fee_short: "অ্যাডমিশন ফি",
    payment_success: "পেমেন্ট সফল! আপনার মেম্বারশিপ চালু হয়েছে।",
    payment_failed: "পেমেন্ট ব্যর্থ বা বাতিল হয়েছে — জিমের ডেস্কে পেমেন্ট করতে পারবেন।",
    book_advance: "বুক করুন · ₹1,000",
    book_success: "বুকিং অ্যাডভান্স পেইড! আমরা শীঘ্রই যোগাযোগ করব।",
  },
};

const LangContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState("en");
  const t = translations[lang];
  return (
    <LangContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LangContext.Provider>
  );
};

export const useLang = () => useContext(LangContext);
